import { Injectable } from '@angular/core';

declare const gtag: (...args: (string | Record<string, string>)[]) => void;

export type ConsentCategory = 'ad_storage' | 'analytics_storage' | 'functionality_storage' | 'security_storage' | 'personalization_storage';

@Injectable({
    providedIn: 'root',
})
export class ConsentService {
    private categories: Record<ConsentCategory, boolean> = {
        ad_storage: false,
        analytics_storage: false,
        functionality_storage: false,
        security_storage: true,
        personalization_storage: false,
    };

    updateConsent(consentMap: Partial<Record<ConsentCategory, boolean>>) {
        const update: Record<string, string> = {};
        for (const key in consentMap) {
            update[key as string] = consentMap[key as ConsentCategory] ? 'granted' : 'denied';
            this.categories[key as ConsentCategory] = consentMap[key as ConsentCategory]!;
        }

        gtag('consent', 'update', update);
        localStorage.setItem('userConsent', JSON.stringify(this.categories));
    }

    loadStoredConsent() {
        const saved = localStorage.getItem('userConsent');
        if (saved) {
            this.updateConsent(JSON.parse(saved));
        }
    }

    hasConsented(category: ConsentCategory): boolean {
        return this.categories[category];
    }
}
